export default __webpack_public_path__ + "static/media/SiteSurveyPdf.26cffbd3.txt";